import { IMAGE_PATH } from './config';

export const getCustomerLogoPath = org => `${IMAGE_PATH}/customer/${org.org_key}/${org.logo_path}`;
